<form autocomplete="off" [name]="formName" [id]="formName" [formGroup]="formControl"
    (ngSubmit)="handleFormSubmit($event)">
    <!-- <shared-forms-date-picker-input [compact]="compact" [parentForm]="formControl" name="dateOfBirth"
        [label]="labelDateOfBirth"></shared-forms-date-picker-input> -->

    <shared-forms-input [compact]="compact" [parentForm]="formControl" name="month" [tabindex]="1" [label]="labelMonth"
        pattern="[0-9]*" [numbersOnly]="true" placeholder="1 - 12" inputmode="numeric" type="text" [maxLength]="2">
    </shared-forms-input>

    <shared-forms-input [compact]="compact" [parentForm]="formControl" name="day" [tabindex]="2" [label]="labelDay"
        pattern="[0-9]*" [numbersOnly]="true" placeholder="1 - 31" inputmode="numeric" type="text" [maxLength]="2">
    </shared-forms-input>


    <shared-forms-input [compact]="compact" [parentForm]="formControl" name="year" [tabindex]="3" [label]="labelYear"
        pattern="[0-9]*" [numbersOnly]="true" placeholder="E.g 1986" inputmode="numeric" type="text" [maxLength]="4"
        [minLength]="4">
    </shared-forms-input>

    <ng-template #left>
        <shared-link [disabled]="(loading$ | async) || formControl.status === 'PENDING'" [emphasis]="emphasis"
            (onClick)="handleSkipStepClick($event)">
            Skip for now!
        </shared-link>
    </ng-template>

    <ng-template #right>
        <shared-forms-submit [loading]="loading$ | async" marginTop="none" width="normal" [parentForm]="formControl">
            Add
        </shared-forms-submit>
    </ng-template>

    <shared-forms-offset-wrapper [topOffset]="modal" [modalOffset]="modal" [left]="left" [right]="right">
    </shared-forms-offset-wrapper>


</form>